module.exports = __webpack_public_path__ + "img/wallet-icon.da7d2d46.svg";